import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import('./views/index.vue')
    },
    {
      path: '/city',
      name: 'city',
      component: () => import('./views/city.vue')
    },
    {
      path: '/paycenter',
      name: 'paycenter',
      component: () => import('./views/paycenter.vue')
    },
    {
      path:'/policy',
      name:'policy',
      component: () => import('./views/policy.vue')
    },
    {
      path: '/shop',
      name: 'shop',
      component: () => import('./views/shop.vue')
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/introduce.vue')
    },
    {
      path: '/myorder',
      name: 'myorder',
      component: () => import('./views/myorder.vue')
    },
    {
      path: '/rules',
      name: 'rules',
      component: () => import('./views/rules.vue')
    },
    {
      path: '/audit',
      name: 'audit',
      component: () => import('./views/audit.vue')
    }
  ]
})
